import React from 'react';
import { InputAdornment, IconButton, IconButtonProps } from '@material-ui/core';
import { Star, StarBorder } from '@material-ui/icons';

export type AdornmentStarProps = IconButtonProps & {
  onToggle?: () => void;
  isFilled: boolean;
};

export const StarAdornment = ({ edge, onToggle, isFilled, ...props }: AdornmentStarProps): JSX.Element => {
  const handleMouseDownAdornment = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();
  };

  const handleClick = () => {
    if (!isFilled) {
      onToggle?.();
    }
  };

  return (
    <InputAdornment position="end">
      <IconButton
        onClick={handleClick}
        onMouseDown={handleMouseDownAdornment}
        {...props}
        edge={edge}
        aria-label="star-adornment"
      >
        {isFilled ? <Star /> : <StarBorder />}
      </IconButton>
    </InputAdornment>
  );
};

export default StarAdornment;
